<template>
  <div>
    <div class="box">
      <div class="imgIcon">
        <!-- <img src="@assets/newHomeIcon/LogFailLoadDBSystem.png" -->
        <img src="@/assets/newHomeIcon/LogFailLoadDBSystem.png" alt />
      </div>
      <p class="spanTs">温馨提示：使用该版块功能请先订购"悦会员"哦~</p>
      <div style="text-align: center">
        <p class="pTwo" @click="subscribe">去订购悦会员</p>
      </div>
      <div style="text-align: center">
        <p class="ppThe">联系客服</p>
      </div>

      <!-- <p class="ppThe">
        QQ：
        <span class="qqSay" @click="qqTan">
          QQ交谈
        </span>
      </p> -->
      <div style="text-align: center">
        <el-button
          @click="qqTan"
          class="qqSay"
          style="
            width: 124px;
            height: 124px;
            position: relative;
            top: 10px;
            border-radius: 6px;
            color: #7f85e9;
            border: 1px solid rgb(174, 179, 241) !important;
          "
          ><i
            class="iconfont iconqq"
            style="
              font-size: 60px;
              color: #7f85e9;
              opacity: 0.15;
              margin-bottom: 10px;
            "
          ></i
          ><br /><span style="top: 5px; position: relative"
            >qq交谈</span
          ></el-button
        >
        <el-button
          class="ppThen"
          style="
            width: 124px;
            height: 124px;
            position: relative;
            top: 17px;
            border: none;
            border: 1px solid #eee !important;
            border-radius: 6px;
            background: #fff !important;
            color: #666;
            left: 16px;
          "
          ><img src="@/assets/newHomeIcon/ppThen.png" alt /><br /><span
            style="top: 5px; position: relative"
            >18925068928</span
          ></el-button
        >
      </div>
      <!-- <p class="ppThe">电话：18925068928</p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {},
  methods: {
    qqTan() {
      window.open(
        "https://wpa.qq.com/msgrd?v=3&uin=800152084&site=qq&menu=yes",
        "_blank"
      );
    },
    subscribe() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1276203?p=fw&t=myarticle",
        "_self"
      );
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .qqSay .el-button {
  background: #ffffff !important;
  &:hover {
    background: #f2f3fd !important;
  }
  &:active {
    background: #ecedfc !important;
  }
}
/deep/ .qqSay .el-button:hover,
.el-button:hover {
  background: #fbfbfe !important;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  top: 4px;
}
/deep/ .qqSay .el-button:hover,
.el-button:focus {
  background: #ecedfc !important;
}
</style>
<style scoped lang="scss">
.box {
  padding: 40px;
  // text-align:center;
  background: #fff;
  margin: 20px;
  height: 835px;
  border-radius: 6px;
  .imgIcon {
    margin: 60px auto;
    height: 200px;
    width: 200px;
    // background-color: #fe4d45;
  }
  .spanTs {
    font-size: 26px;
    text-align: center;
  }
  .iconqq {
  }
  .pTwo {
    margin: 0 auto;
    width: 214px;
    padding: 9px 0;
    height: 40px;
    font-size: 20px;
    color: #7f85e9;
    cursor: pointer;
    //  margin-top: 20px;
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 4px;
    background-color: #fff4f4;
    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    margin-top: 20px;
  }
  .ppThe {
    width: 190px;
    margin: 0 auto;

    font-size: 20px;
    margin-top: 32px;
    .qqSay {
      position: relative;
      width: 124px;
      height: 124px;
      font-size: 12px;
      background: linear-gradient(89deg, #356aff 100%, #0840de 100%);
      opacity: 1;
      border-radius: 6px;
      padding: 1px 7px;
      color: #fff;
      margin-left: 5px;
      margin-right: 12px;
      bottom: 2px;
      cursor: pointer;
      &:hover {
        bottom: 4px;
        box-shadow: 3px 3px 15px #ddd;
      }
      .iconqq {
        // width: 60px;
        font-size: 60px;
      }
    }
    .ppThen {
      position: relative;
      width: 124px;
      height: 124px;
      font-size: 12px;
      background: #fff;
      opacity: 1;
      border-radius: 6px;
      padding: 1px 7px;
      color: #fff;
      margin-left: 5px;
      margin-right: 12px;
      bottom: 2px;
      cursor: pointer;
      //  &:hover {
      //   bottom: 4px;
      //   box-shadow: 3px 3px 15px #ddd;
      // }
    }
  }
}
</style>
